export enum IconoAccion{

    CREAR = "log-in",
    EDITAR = "edit",
    BORRAR = "trash"
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/modelo/IconoAccion.ts